<template>
  <v-container grid-list-md pa-0 ma-0 pl-3  style="max-width: calc(100% - 16px)">
    <v-dialog v-model="dialogDeactivate" width="400px">
      <v-card>
        <v-card-text style="height: 100px">
          <h2 class="text-xs-center mt-4">Tem certeza que quer desativar estes estímulos?</h2>
        </v-card-text>
        <v-card-actions class="mt-2">
          <v-spacer />
          <v-btn color="primary" outline dark @click="dialogDeactivate = false"> Não </v-btn>
          <v-btn class="elevation-1" color="primary" dark @click="deactivateStimulus"> Desativar </v-btn>
          <v-spacer />
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-layout row wrap fill-height>
      <StimulusHeader
        :has-active-selected="hasActiveSelected"
        :loading="loading"
        :order-debt-bases="orderDebtBases"
        :select-all-checkbox="selectAllCheckbox"
        :selected-base-id="selectedBaseId"
        :selected-creditor="selectedCreditor"
        :selected-stimulus-length="selectedStimulus.length"
        :set-select-tree="setSelectTree"
        :stimulus-active="stimulusActive"
        @change-select-all-checkbox="selectAllCheckbox = $event"
        @change-selected-base-id="selectedBaseId = $event"
        @change-stimulus-active="handleStimulusActiveChange"
        @clear-selection="clearSelectedStimulus"
        @open-dialogs-dates="openDialogsDates"
        @open-multiple-dialog-archiving-stimulus="openMultipleDialogArchivingStimulus"
        @prepare-stimulus="prepareStimulus"
        @selected-creditors="changeSelectCreditors"
      />

      <!-- Loading -->
      <v-flex xs12 class="text-xs-center mt-5" v-if="loading">
        <v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
      </v-flex>

      <!-- Lista com ordenação -->
      <v-flex xs12 class="pb-5 mb-5 px-3 pt-3" v-else-if="stimulusList.length">
        <div class="qj-order">
          <!-- Lista -->
          <v-list dense three-line class="pa-0" style="width: 100%;" v-if="stimulusList.length">
            <draggable name="drag" ghost-class="qj-ghost" @change="onUnpublishedChange()" v-model="stimulusList"
              :move="onMoveCallBack">
              <template v-for="(item, index) in stimulusList">
                <div :tag="item.id" :key="item.id">
                  <v-list-tile class="qj-list-draggable" :style="`${item.active ? '' : 'opacity:.5;'}`">
                    <div class="qj-order-list-item">
                      {{ index + 1 }}
                    </div>
                    <!-- Breadcrumbs -->
                    <div class="qj-breadcrumbs"
                      :style="`${item.active ? 'background: #fafafa;' : 'background: #ddd9d9;'}`">
                      <v-layout row class="pa-1">
                        <v-breadcrumbs divider=">" class="pa-0 ma-0"
                          :items="util.mountBreadCrumb({ ...item.node_depth })">
                          <template v-slot:item="props">
                            <samp samp 
                              class="primary--text font-weight-bold pl-2"
                              v-if="props.item.id != item.debt_node.id || item.debt_node.active"
                            >
                              {{ props.item.text.toUpperCase() }}
                            </samp>
                            <v-tooltip bottom v-else>
                              <template v-slot:activator="{ on }">
                                <samp class="font-weight-bold red--text" v-on="on">
                                  <v-icon size="14" class="red--text text--darken-1" v-if="props.item.id == item.debt_node.id &&
                                    !item.debt_node.active
                                    ">
                                    mdi-alert-circle </v-icon>{{ props.item.text.toUpperCase() }}
                                </samp>
                              </template>
                              <span>Nó excluido, os disparos não serão realizados!</span>
                            </v-tooltip>
                          </template>
                        </v-breadcrumbs>
                        <v-spacer></v-spacer>
                        <span class="primary--text pr-3" style="font-size: 10px;">Editado por {{ item.last_modification_user }}
                          {{ item.updated_at | formatDateTime }}</span>
                      </v-layout>
                    </div>
                    <div class="qj-stimulus">
                      <v-checkbox class="qj-checkbox" v-model="selectedStimulus" :value="item">
                      </v-checkbox>
                      <!-- Icone -->
                      <v-icon :style="`${item.active ? 'cursor: move; position: relative;' : ''}`"
                        class="ml-8 mt-4">mdi-drag-vertical</v-icon>
                      <!-- Btn status -->
                      <v-list-tile-avatar class="mr-2 ml-3 mt-4">
                        <v-btn fab dark small :style="item.active_at ? '' : 'opacity:.4;'" color="primary"
                          class="ma-0 elevation-0" @click="openDialogDate(item)">
                          <v-icon dark>mdi-{{ icon(item.active_at) }}</v-icon>
                        </v-btn>
                      </v-list-tile-avatar>
                      <!-- Conteudo -->
                      <v-list-tile-content class="pt-5 pb-2">
                        <!-- Titulo -->
                        <v-list-tile-title style="
                            height: 16px;
                            line-height: 17px;
                            display: flex;
                            align-items: center;
                          ">
                          <h6 class="text--primary subheading font-weight-medium mr-1" style="display: initial">
                            {{ item.id }}. {{ item.name }}
                          </h6>
                          <stimulus-chips :stimulus="item" />

                        </v-list-tile-title>
                        <!-- Descrição -->
                        <v-list-tile-sub-title v-if="item.approach_flow">
                          <a @click="goToTreeApproaches(item)">
                            <span class="indigo--text" v-if="item.approach_flow.active">
                              {{ item.approach_flow.id }}. {{ item.approach_flow.name }}
                            </span>
                            <v-tooltip bottom v-else>
                              <template v-slot:activator="{ on }">
                                <span v-on="on" class="font-italic">
                                  <s>{{ item.approach_flow.name }}</s>
                                </span>
                              </template>
                              <span>Essa abordagem esta em desuso!</span>
                            </v-tooltip>
                          </a>
                        </v-list-tile-sub-title>
                        <v-list-tile-sub-title v-if="item.approach_flow">
                        <span class="text--primary" style="font-size: 10px;" v-if="active(item)">
                          A partir de {{ item.active_at | formatDateUTC }}
                        </span>
                        </v-list-tile-sub-title>
                        <!--  -->
                        <v-list-tile-sub-title v-if="!item.debt_node.active && false">
                          <div class="red lighten-4 red--text text--darken-2" style="
                              display: flex;
                              align-items: center;
                              justify-content: center;
                              vertical-align: middle;
                              padding: 2px 7px 2px 3px;
                              border-radius: 4px;
                              border-left: 4px solid #d32f2f !important;
                            ">
                            <v-icon size="14" class="red--text text--darken-1" style="margin-right: 3px">
                              mdi-alert-circle
                            </v-icon>
                            <span class="red lighten-4 red--text text--darken-2"
                              style="margin-top: 2px; font-size: 11px; line-height: 12px">
                              Nó excluido, os disparos não serão realizados!
                            </span>
                          </div>
                        </v-list-tile-sub-title>

                        <!-- approach rule chips -->
                        <v-list-tile-sub-title>
                          <approach-rule-chips :item="item" />
                        </v-list-tile-sub-title>

                      </v-list-tile-content>
                      <!-- Ações do item -->
                      <div :key="keyToReload" style="
                          display: flex;
                          height: 100%;
                          align-items: center;
                        ">
                        <!-- Menu -->
                        <v-menu bottom left>
                          <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" class="qj-pontos">
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list>
                            <v-list-tile @click="openMetabase(item)">
                              <v-list-tile-title>
                                Analisar
                                <v-icon small class="ml-1" style="margin-bottom: 1px">
                                  mdi-open-in-new
                                </v-icon>
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="openMetabase(item, true)">
                              <v-list-tile-title>
                                Analítico
                                <v-icon small class="ml-1" style="margin-bottom: 1px">
                                  mdi-open-in-new
                                </v-icon>
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-divider />
                            <v-list-tile @click="openDialogStimulus(item.hot, item)">
                              <v-list-tile-title>
                                <v-icon small class="mr-1">
                                  mdi-pencil
                                </v-icon>
                                Editar
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="cloneApproach(item.hot, item)">
                              <v-list-tile-title>
                                <v-icon small class="mr-1">
                                  mdi-content-copy
                                </v-icon>
                                Clonar
                              </v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile @click="openDialogArchivingStimulus(item)">
                              <v-list-tile-title>
                                <v-icon small class="mr-1">
                                  {{ !item.active ? 'mdi-archive-arrow-up' : 'mdi-archive-arrow-down' }}
                                </v-icon>
                                {{
                                  !item.active ? "Desarquivar" : "Arquivar"
                                }}
                              </v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                  </v-list-tile>
                  <v-divider v-if="!isLastItem(index)" />
                </div>
              </template>
            </draggable>
          </v-list>
        </div>
      </v-flex>

      <!-- Sem dados -->
      <v-flex xs12 class="text-xs-center mt-5" v-else>
        <p class="title mb-0">Não há dados para carregar na árvore.</p>
      </v-flex>
    </v-layout>

    <!-- Novo estímulo -->
    <v-speed-dial fixed bottom transition="scale-transition" :right="$vuetify.breakpoint.mdAndUp"
      :direction="$vuetify.breakpoint.mdAndUp ? 'left' : 'top'" v-model="fab">
      <template v-slot:activator>
        <v-btn v-model="fab" color="accent" dark fab :disabled="!selectedBaseId">
          <v-icon>add</v-icon>
          <v-icon>close</v-icon>
        </v-btn>
      </template>
      <v-btn dark round class="text-xs-left" :key="key" :color="tab.color" @click="openDialogStimulus(tab.hot)"
        v-for="(tab, key) in fabButtons">
        {{ tab.name }}
      </v-btn>
    </v-speed-dial>

    <v-dialog width="290px" v-model="dialogDate">
      <v-date-picker locale="pt-br" :min="yesterday" v-model="date" style="position: relative">
        <v-btn flat icon class="ma-0" color="white" @click="dialogDate = false"
          style="position: absolute; top: 5px; z-index: 1; right: 5px">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn flat class="ma-0" color="primary" @click="dialogDate = false">Cancelar</v-btn>
        <v-btn flat class="ma-0" color="primary" @click="saveDate">Ativar</v-btn>
      </v-date-picker>
    </v-dialog>

    <DialogConfirmPrepare
      :dialog.sync="dialogConfirmPrepare"
      :selected-stimulus="selectedStimulus"
      :has-invalid-prepare-day="hasInvalidPrepareDay"
      :invalid-trees="invalidTrees"
      @confirm-prepare="confirmPrepareStimulus"
    />

    <!-- Dialog dos estímulos -->
    <DialogStimulus
      :node="node"
      :dataTest="dataDialogStimulus"
      :dialog.sync="dialogStimulus"
      :creditorId="selectedCreditor"
      :minOrder="minOrder"
      :campaigns="campaigns"
      :segments="segments"
      :approachList="approachList"
      :creditor_profiles="creditor_profiles"
      :tags_v2="tags_v2"
      :contact_tags_v2="contact_tags_v2"
      :customer_tag="customer_tag"
      :nodes="nodes"
      :loadingNodes="loadingNodes"
      :loadindDialog="loadingDialog"
    />
    <!-- Dialog para arquivar estímulos-->
    <DialogArchivingStimulus
      :active="activeStimulus"
      :dialog.sync="dialogArchivingStimulus"
      :isMultiple="isMultiple"
      @archiveStimulus="switchStatus"
      @archiveMultiStimulus="switchMultiStatus"
    />
  </v-container>
</template>

<script>
import store from "@/store";
import draggable from "vuedraggable";

//services
import segmentService from "@/services/consolidation-tree/segments";
import stimulusService from "@/services/consolidation-tree/stimulus";
import campaignService from "@/services/consolidation-tree/campaign";
import dealTagsService from "@/services/consolidation-tree/deal-tags";
import approachService from "@/services/consolidation-tree/approach-flow";
import contactTagService from "@/services/consolidation-tree/contact-tags";
import customerTagService from "@/services/consolidation-tree/customer-tag";
import treeService from "@/services/consolidation-tree/consolidation-tree";
import creditorProfileService from "@/services/consolidation-tree/creditor-profile"

//components
import util from "./components/utils/util";
import TreeLocated from "./components/trees/treeLocated";
import TreeNotLocated from "./components/trees/treeNotLocated";
import DialogConfirmPrepare from "./components/dialogs/DialogConfirmPrepare.vue";
import DialogStimulus from "./components/dialogs/dialogStimulus";
import StimulusHeader from "./components/StimulusHeader.vue";
import DialogArchivingStimulus from "./components/dialogs/dialogArchivingStimulus.vue";
import ApproachRuleChips from "./components/ApproachRuleChips.vue";
import StimulusChips from "./components/StimulusChips.vue";

export default {
  name: "consolidation-tree",
  components: {
    draggable,
    TreeLocated,
    TreeNotLocated,
    DialogConfirmPrepare,
    DialogStimulus,
    StimulusHeader,
    DialogArchivingStimulus,
    ApproachRuleChips,
    StimulusChips,
  },
  data: function () {
    return {
      util: util,
      fab: false,
      hover: true,
      keyToReload: 1,
      loadingNodes: false,
      loadingDialog: false,
      loading: false,
      dialogDate: false,
      dialogConfirmPrepare: false,
      isMultiple: false,
      stimulusActive: false,
      dialogStimulus: false,
      dialogArchivingStimulus: false,
      hasActiveSelected: false,
      treeKey: 0,
      selectedStimulus: [],
      selectAllCheckbox: false,
      unselectStimulus: false,
      selectedCreditor: 0,
      node: "",
      stimulus: null,
      activeStimulus: "",
      stimulusId: "",
      isClone: false,
      debtBases: [],
      creditors: [],
      campaigns: [],
      segments: [],
      approachList: [],
      SegmentFilter: [],
      stimulusList: [],
      creditor_profiles: [],
      creditoProfilesFilter: [],
      tags_v2: [],
      tagsFilter: [],
      contact_tags_v2: [],
      contactTagsFilter: [],
      customer_tag: [],
      customerTagsFilter: [],
      nodes: [],
      dialogDeactivate: false,
      fabButtons: [
        {
          name: "Não localizado",
          color: "orange",
          hot: false,
        },
        {
          name: "Localizado",
          color: "red",
          hot: true,
        },
      ],
      stimulusHistory: {},
      dataDialogStimulus: {},
      dataDialogArchivingStimulus: {},
      selectedNodeId: null,
      selectedBaseId: null,
      date: null,
      movedStimulus: null,
      minOrder: null,
    };
  },
  computed: {
    orderDebtBases() {
      if (!this.debtBases.length) return [];
      let stimulate = this.debtBases.filter((db) => db.status == "STIMULATE");
      let analyzable = this.debtBases.filter((db) => db.status == "ANALYZABLE");
      let archived = this.debtBases.filter((db) => db.status == "ARCHIVED");
      return stimulate.concat(analyzable, archived);
    },
    getTreeSelected() {
      if (!this.selectedBaseId) return {};
      return this.debtBases.find((db) => db.id == this.selectedBaseId) || {};
    },
    idNodeRoot() {
      if (!this.debtBases.length || !this.selectedBaseId) return null;
      if (!this.getTreeSelected.nodes) return null;
      if (!this.getTreeSelected.nodes.length) return null;
      return this.getTreeSelected.nodes[0].id || null;
    },
    yesterday() {
      return new Date(new Date().setDate(new Date().getDate() - 1)).toISOString();
    },
    hasInvalidPrepareDay() {
      const jsDay = new Date().getDay();
      const today = (jsDay + 6) % 7; // Converte JS (0=domingo) para Python (0=segunda)
      return this.selectedStimulus.some(stimulus => {
        const prepareWeekDays = this.getPrepareWeekDays(stimulus);
        return !prepareWeekDays.includes(today);
      });
    },
    invalidTrees() {
      const jsDay = new Date().getDay();
      const today = (jsDay + 6) % 7; // Converte JS (0=domingo) para Python (0=segunda)
      const invalid = [];
      this.selectedStimulus.forEach(stimulus => {
        const prepareWeekDays = this.getPrepareWeekDays(stimulus);
        if (!prepareWeekDays.includes(today)) {
          const treeName = (stimulus.debt_node && stimulus.debt_node.debt_base && stimulus.debt_node.debt_base.name) || 'Desconhecida';
          if (!invalid.includes(treeName)) {
            invalid.push(treeName);
          }
        }
      });
      return invalid;
    },
  },
  watch: {
    selectedBaseId() {
      this.keyToReload += 1
      if (!this.loading) {
        this.getStimulus();
        this.addfilters();
      }
      setTimeout(() => {
        this.keyToReload += 1
        this.getNodes();
      }, 500)
    },
    selectedStimulus() {
      let activeSelected = 0
      this.selectedStimulus.forEach(item => {
        if (item.active_at) {
          activeSelected += 1;
        }
      })
      if (this.selectedStimulus.length < this.stimulusList.length){
        this.selectAllCheckbox = false;
        this.unselectStimulus = true;
      }
      else if (this.selectedStimulus.length == this.stimulusList.length && this.stimulusList.length){
        this.selectAllCheckbox = true;
        this.unselectStimulus = false;
      }
      if (activeSelected>0){
        this.hasActiveSelected = true;
      }
      else{
        this.hasActiveSelected = false;
      }
    },
    dialogStimulus: {
      async handler() {
        if (!this.dialogStimulus) {
          this.selectedNodeId = null;
          this.getStimulus();
          this.addfilters();
        } else {
          this.minOrder = Math.min(...this.stimulusList.map(obj => obj.order));
        }
      },
    },
    selectAllCheckbox(newVal) {
      if (newVal) {
        this.stimulusList.forEach((item) => {
          if(this.selectedStimulus.includes(item)) return; 
          else this.selectedStimulus.push(item)
        }

      );
        this.unselectStimulus = false;
      } 
      else if(this.unselectStimulus){
        this.unselectStimulus = false;
      }
      else {
        this.selectedStimulus = [];
      }
    },
    dialogArchivingStimulus: {
      async handler() {
        if (!this.dialogArchivingStimulus) {
          this.activeStimulus = null;
        }
      },
    },
    dialogDate() {
      if (!this.dialogDate);
    },
  },
  methods: {
    onMoveCallBack(e) {
      this.movedStimulus = e.draggedContext.element.id;
    },
    async fetchDialogData() {
      if (!this.selectedCreditor) return;

      this.loadingDialog = true;
      try {
        await Promise.all([
          this.fetchApproachFlowList(),
          this.getCampaing(),
          this.getCreditorProfile(),
          this.getDealTags(),
          this.getcontactTags(),
          this.getCustomerTags(),
          this.getSegments(),
        ]);
      } catch (e) {
        console.error(e);
      } finally {
        this.loadingDialog = false;
      }
    },
    async switchStatus() {
      let status = !this.stimulus.active;
      let statusMessage = status ? "desarquivado" : "arquivado";
      stimulusService
        .update(this.stimulus.id, {
          active: status,
          last_modification_user: this.$store.getters.getLoggedUser.name,
        })
        .then(async (res) => {
          this.$store.commit("showSnackbar", {
            important: true,
            message: `${this.stimulus.name} ${statusMessage} com sucesso!`,
          });
          await this.getStimulus();
          setTimeout(() => {
            this.onUnpublishedChange(false);
          }, 1000);
        })
        .catch((e) => {
          this.$store.commit("showSnackbar", `Houve um erro!`);
        });
    },
    async getNodes() {
      if (this.loadingNodes || !this.selectedBaseId || !this.idNodeRoot) {
        return;
      }

      let lvl = 0;
      let resp = null;
      var items = [];

      this.loadingNodes = true;
      this.nodes = [];

      try {        
        resp = await treeService.getNode(this.idNodeRoot, ["children"]);
      } catch(e) {
        console.error("Não foi possível carregar os nós", e);
        this.$store.commit("showSnackbar", {
          important: true,
          message: "Não foi possível carregar os nós",
        });

      } finally {
        this.loadingNodes = false;
      }

      if (!resp) return;

      const addNodes = (no) => {
        for (let i = 0; i < no.length; i++) {
          let preName = "";
          for (let j = 0; j < lvl; j++) preName += "—";
          // if (preName) preName += ">";
          items.push({
            id: no[i].id,
            text: no[i].name,
            fullText: preName + " " + no[i].name,
          });
          if (no[i].children && no[i].children.length) {
            lvl++;
            addNodes(no[i].children);
          }
        }
        lvl--;
        return;
      };
      addNodes([resp]);

      this.nodes = items;
    },     
    async getSegments(){
            
        this.segments = await segmentService.list({params:{creditor_id: this.selectedCreditor}});


        if (this.segments.length > 0){
          this.SegmentFilter = [{ header: "Inclusão" }]

          this.segments.forEach(seg =>{
              if (seg[0] != '-'){
                  this.SegmentFilter.push(
                      { name: seg }                    
                  )
              }
          })

          this.SegmentFilter.push({ header: "Exclusão" })

          this.segments.forEach(seg => {
              if (seg[0] == '-'){
                  this.SegmentFilter.push(
                      { name: seg }                    
                  )
              }
          });

          this.SegmentFilter.unshift(
              "Sem-segmento",
          );              

        }
        else
        {
          this.segments.unshift(
              "Sem-segmento",
          );     

        }
        
    },
    async getCampaing(){
      this.campaigns = await campaignService.list({params:{creditor_id: this.selectedCreditor}});
      this.campaigns = this.campaigns.filter(function(campaigns){
        return campaigns.key || campaigns.desc
      });

      this.campaigns.unshift({
      key: "Sem-campanha",
      desc: "Sem-campanha"
      });
    },
    async fetchApproachFlowList() {
      if (this.loadingApproachFlow) {
        return;
      }

      this.approachList = [];
      this.loadingApproachFlow = true;

      try {
        await this.loadApproachFlowList();
      } catch (e) {
        if (this.isNonTransientError(e)) {
          console.error("Não foi possível carregar os fluxos de abordagem", e);
          this.$store.commit("showSnackbar", {
            important: true,
            message: "Não foi possível carregar os fluxos de abordagem",
          });
          this.loadingApproachFlow = false;
          return;
        }

        console.error("Não foi possível carregar os fluxos de abordagem, tentando novamente", e);
        await this.delay(1000);

        try {
          await this.loadApproachFlowList();
        } catch (retryError) {
          console.error("Não foi possível carregar os fluxos de abordagem", retryError);
          this.$store.commit("showSnackbar", {
            important: true,
            message: "Não foi possível carregar os fluxos de abordagem",
          });
        }
      } finally {
        this.loadingApproachFlow = false;
      }
    },
    async loadApproachFlowList() {
      let response = await approachService.listAll(this.selectedCreditor);
      this.approachList = response.objects;
    },
    isNonTransientError(error) {
      const status = error && error.response && error.response.status;
      return status >= 400 && status < 500;
    },
    delay(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async getCreditorProfile(){
      this.creditor_profiles = await creditorProfileService.list({params:{creditor_id: this.selectedCreditor}});
      this.creditor_profiles = this.creditor_profiles.filter(function(creditor_profiles){
          return creditor_profiles
      });

      if (this.creditor_profiles.length > 0){
        this.creditoProfilesFilter = [{ header: "Inclusão" }]

        this.creditor_profiles.forEach(cred =>{
            if (cred[0] != '-'){
                this.creditoProfilesFilter.push(
                    { name: cred }                    
                )
            }
        })

        this.creditoProfilesFilter.push({ header: "Exclusão" })

        this.creditor_profiles.forEach(cred => {
            if (cred[0] == '-'){
                this.creditoProfilesFilter.push(
                    { name: cred }                    
                )
            }
        });

        this.creditoProfilesFilter.unshift(
            "Sem-perfil",
        );
      }
      else{

        this.creditor_profiles.unshift(
            "Sem-perfil",
        );

      }
    },
    async getDealTags(){
      this.tags_v2 = await dealTagsService.list({params:{creditor_id: this.selectedCreditor}});
      this.tags_v2 = this.tags_v2.filter(function(tags_v2){
          return tags_v2
      });


      if (this.tags_v2.length > 0){

        this.tagsFilter = [{ header: "Inclusão" }]

        this.tags_v2.forEach(tag =>{
            if (tag[0] != '-'){
                this.tagsFilter.push(
                    { name: tag }                    
                )
            }
        })

        this.tagsFilter.push({ header: "Exclusão" })

        this.tags_v2.forEach(tag => {
            if (tag[0] == '-'){
                this.tagsFilter.push(
                    { name: tag }                    
                )
            }
        });

        this.tagsFilter.unshift(
            "Sem-tags",
        );

      }
      else{
        this.tags_v2.unshift(
          "Sem-tags",
        );
      }
      
    },
    async getcontactTags(){
      this.contact_tags_v2 = await contactTagService.list({params:{creditor_id: this.selectedCreditor}});
      this.contact_tags_v2 = this.contact_tags_v2.filter(function(tag){
          return tag
      });          
      
      if (this.contact_tags_v2.length > 0){
        this.contactTagsFilter = [{ header: "Inclusão" }]

        this.contact_tags_v2.forEach(tag =>{
            if (tag[0] != '-'){
                this.contactTagsFilter.push(
                    { name: tag }                    
                )
            }
        })

        this.contactTagsFilter.push({ header: "Exclusão" })

        this.contact_tags_v2.forEach(tag => {
            if (tag[0] == '-'){
                this.contactTagsFilter.push(
                    { name: tag }                    
                )
            }
        });

        this.contactTagsFilter.unshift(
            "Sem-tags",
        );

        } else {
          this.contact_tags_v2 = ["Sem-tags"];
        }
    },  
    async getCustomerTags(){
      this.customer_tag = await customerTagService.getCustomerTags(this.selectedCreditor);
      this.customer_tag = this.customer_tag.filter(function(tag){
          return tag
      });          
      
      if (this.customer_tag.length > 0){
        this.customerTagsFilter = [{ header: "Inclusão" }]

        this.customer_tag.forEach(tag =>{
            if (tag[0] != '-'){
                this.customerTagsFilter.push(
                    { name: tag }                    
                )
            }
        })

        this.customerTagsFilter.push({ header: "Exclusão" })

        this.customer_tag.forEach(tag => {
            if (tag[0] == '-'){
                this.customerTagsFilter.push(
                    { name: tag }                    
                )
            }
        });

        this.customerTagsFilter.unshift(
            "Sem-tags",
        );

        } else {
          this.customer_tag = ["Sem-tags"];
        }
    },  
    async switchMultiStatus() {
      this.selectedStimulus.forEach((stimulus) => {
      let status = !stimulus.active;
      let statusMessage = status ? "desarquivado" : "arquivado";
      stimulusService
        .update(stimulus.id, {
          active: status,
          last_modification_user: this.$store.getters.getLoggedUser.name,
        })
        .then(async (res) => {
          this.$store.commit("showSnackbar", {
            important: true,
            message: `${stimulus.name} ${statusMessage} com sucesso!`,
          });
          await this.getStimulus();
          setTimeout(() => {
            this.onUnpublishedChange(false);
          }, 1000);
        })
        .catch((e) => {
          this.$store.commit("showSnackbar", `Houve um erro!`);
        });
      })
    },
    async getStimulus() {
      this.stimulusList = [];

      if (!this.selectedBaseId) return;

      this.loading = true;
      this.selectedStimulus = [];
      this.selectAllCheckbox = false;
      this.unselectStimulus = false;

      await stimulusService
        .list(this.selectedBaseId, !this.stimulusActive)
        .then(async (resp) => {
          this.stimulusList = resp.objects.sort((a, b) => {
            if (a.active && b.active) {
              if (a.order < b.order) return -1;
              if (a.order > b.order) return 1;
            }
            else if (!a.active && !b.active) {
              if (a.updated_at < b.updated_at) return 1;
              if (a.updated_at > b.updated_at) return -1;
            }
            return 0;
          });

          let hasDuplicates = (array) => {
            return new Set(array).size !== array.length;
          };

          if (hasDuplicates(this.stimulusList.map((s) => s.order))) {
            this.onUnpublishedChange(false);
          }

        })
        .catch(() => {
          this.$store.commit("showSnackbar", {
            message: "Não foi possível carregar os estímulos",
            important: true,
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    openDialogDate(stimulus) {
      if (stimulus.active_at) {
        this.dialogDeactivate = true;
        this.stimulusId = stimulus.id;
      }
      else {
        this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        this.stimulusId = stimulus.id;
        this.dialogDate = true;
      }
    },
    openDialogsDates(hasActiveSelected) {
      if (hasActiveSelected) {
        this.dialogDeactivate = true;
        hasActiveSelected = false; 
      }
      else {
        this.date = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
        this.stimulusId = this.stimulusList;
        this.dialogDate = true;
      }
    },
    deactivateStimulus() {
      this.date = null;
      this.saveDate();
    },
    saveDate() {
      let newDate = this.date ? this.date + "T00:00:00" : null;
      if(this.selectedStimulus.length > 0){
        stimulusService
        .updateList({
          stimulus: this.selectedStimulus,
          active_at: newDate,
          last_modification_user: this.$store.getters.getLoggedUser.name,
        })
        .then(async (res) => {
          await this.getStimulus();
        })
        .catch((e) => {
          console.error(e);
          this.$store.commit("showSnackbar", `Houve um erro ao salvar!`);
        });
      }
      else{
        stimulusService
          .update(this.stimulusId, {
            active_at: newDate,
            last_modification_user: this.$store.getters.getLoggedUser.name,
          })
          .then(async (res) => {
            await this.getStimulus();
          })
          .catch((e) => {
            console.error(e);
            this.$store.commit("showSnackbar", `Houve um erro ao salvar!`);
          });
      }
      this.dialogDate = false;
      this.dialogDeactivate = false;
    },
    active(stimulus) {
      if (stimulus.active_at > new Date(new Date().setDate(new Date().getDate())).toISOString()) return true;
    },
    /**
     * Carrega todos os credores.
     */
    /**
     * Carrega a query.
     *
     * @returns Retorna um objeto com os filtros da url.
     */
    getQuery() {
      let query = this.$route.query;
      if (query && !Object.keys(query).length) {
        query = store.getters.getDebtTreeFilters;
      }
      this.setQuery(query);
      return query;
    },
    /**
     * Adiciona os filtros na url.
     *
     * @param {Object} query filtros
     */
    setQuery(query) {
      this.$store.commit("setDebtTreeFilters", query);
      if (this.$route.path == "/debt-tree/stimulus") {
        this.$router.replace({
          name: "Estímulos",
          query: query,
        });
      }
    },
    goToTreeApproaches(strategy) {
      this.$router.push({
        name: "Fluxo de abordagem",
        params: {
          edit: true,
          approach_id: strategy.approach_flow.id,
        },
      });
    },
    async changeSelectCreditors(id, permission = false) {
      if ((this.loading && !permission) || !id) return;
      this.stimulusList = [];
      this.stimulusHistory = [];
      this.selectedCreditor = id;
      await this.fetchBebtBases();
      this.fetchDialogData();
      if (!this.loading && !permission) {
        this.selectedBaseId = null;
      }
      this.addfilters();
    },
    async adminStimulus(nodeId) {
      this.selectedNodeId = nodeId;
      this.addfilters();
      this.dialogStimulus = true;
    },
    async archiveStimulus(stimulus) {
      this.activeStimulus = stimulus.active;
      this.dialogArchivingStimulus = true;
    },
    async fetchBebtBases() {
      let bases = null;

      this.loading = true;
      this.debtBases = [];

      try {
        bases = await treeService.listDebtBases(this.selectedCreditor);
      } catch {
        this.$store.commit("showSnackbar", {
          message: "Não foi possível carregar as estruturas de árvore",
          important: true,
        });

        return;
      } finally {
        this.loading = false;
      }

      this.debtBases = bases.objects;
      if (this.debtBases.length == 1) {
        setTimeout(() => {
          this.selectedBaseId = this.debtBases[0].id;
        });
      } else if (!this.selectedBaseId) {
        var debtBase = this.debtBases.find((d) => d.status == "STIMULATE");
        if (debtBase && debtBase.id) {
          setTimeout(() => {
            this.selectedBaseId = debtBase.id;
          });
        }
      }
    },
    addfilters() {
      // if (this.loading) return;
      let query = {};
      if (this.selectedCreditor) {
        query.creditor = this.selectedCreditor;
        if (this.selectedBaseId) {
          query.baseId = this.selectedBaseId;
          if (this.selectedNodeId) query.nodeId = this.selectedNodeId;
        }
      }
      this.setQuery(query);
    },
    isLastItem(index) {
      return this.stimulusList.length - 1 == index;
    },
    async onUnpublishedChange(snackbar = true) {
      if (!this.movedStimulus) return
      try {
        if (!this.stimulusActive && this.movedStimulus) {
          let listIds = this.stimulusList.map((s) => s.id);
          stimulusService.updateOrder(
            this.movedStimulus, {
            order: listIds,
            last_modification_user: this.$store.getters.getLoggedUser.name,
          })
            .then(async (res) => {
              await this.getStimulus();
            })
          if (snackbar) {
            this.$store.commit("showSnackbar", {
              important: true,
              message: "Ordenado(s) com sucesso!",
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    /**
     * Carrega as informação do gráfico e os detalhes,
     * como cor, icon, etc.
     *
     * @param {Object} data Histórico de simulações.
     * @param {String} type Tipo de histórico.
     * @param {Boolean} isHot Definição se é ou não hot.
     * @returns Retorna um Object com os dados do gráfico e detalhes.
     */
    dataChart(id, type = "cpp") {
      let answer = {
        values: [0, 0, 0, 0, 0],
        lestValue: 0,
        icon: "mdi-minus",
        color: "amber",
      };
      let history = this.stimulusHistory[id];
      if (!history) return answer;
      history = history[type];
      if (!history) return answer;

      for (let index = 0; index < 5; index++) {
        answer.values[4 - index] = history[index] ? history[index] : 0;
      }
      answer.lestValue = answer.values[4];

      let totalValue = 0;
      answer.values.forEach((v) => (totalValue += v));
      let mediaValue = totalValue / 5;
      if (answer.lestValue > mediaValue) {
        if (type == "penetration") {
          answer.color = "green";
        } else {
          answer.color = "red";
        }
        answer.icon = "mdi-arrow-up";
      } else if (answer.lestValue < mediaValue) {
        if (type == "penetration") {
          answer.color = "red";
        } else {
          answer.color = "green";
        }
        answer.icon = "mdi-arrow-down";
      } else if (answer.lestValue == mediaValue) {
        answer.color = "amber";
        answer.icon = "mdi-minus";
      }

      return answer;
    },
    openDialogStimulus(hot, edit = {}) {
      if (!edit.id) {
        let num = this.stimulusList.length + 1;
        this.dataDialogStimulus = {
          active: true,
          filters: {},
          hot: hot,
          order: num,
          name: `Estímulo ${num}`,
        };
      } else {
        this.dataDialogStimulus = { ...edit };
      }
      this.dialogStimulus = true;
      this.fetchDialogData();
    },
    cloneApproach(hot, edit = {}){
      this.isClone = true;
      let num;
      if(this.toTop){
        let menorOrder = Math.min(...this.stimulusList.map(obj => obj.order));
        num = menorOrder - 1;
      }else{
        num = this.stimulusList.length + 1;
      }
      this.dataDialogStimulus = {
        active: true,
        hot: hot,
        order: num,
        name: `Clone de ${edit.name}`,
        isClone: this.isClone,
        debt_node_id: edit.debt_node_id,
        approach_flow_id: edit.approach_flow_id,  
        filters: edit.filters,
        daily_budget: edit.daily_budget,
      };
      
      this.dialogStimulus = true;
      this.fetchDialogData();
    },
    openDialogArchivingStimulus(stimulus) {
      this.stimulus = stimulus;
      this.isMultiple = false;
      this.activeStimulus = stimulus.active;
      this.dialogArchivingStimulus = true;
    },
    openMultipleDialogArchivingStimulus() {
        this.dialogArchivingStimulus = true;
        this.isMultiple = true;
    },
    clearSelectedStimulus() {
      this.selectedStimulus = [];
      this.selectAllCheckbox = false;
    },
    handleStimulusActiveChange(value) {
      this.stimulusActive = value;
      this.getStimulus();
    },
    openMetabase(config, isAnalytical = false) {
      const LOCATED = "https://metabase.quiteja.com.br/dashboard/280?estimulo=";
      const NOT_LOCATED = "https://metabase.quiteja.com.br/dashboard/266?estimulo=";
      const ANALYTICAL =
        "https://metabase.quiteja.com.br/question/3753-analitico-estimulos?data=" +
        new Date().toISOString().slice(0, 10) +
        "&data_final=" +
        new Date().toISOString().slice(0, 10) +
        "&No=";

      if (isAnalytical) {
        var link = ANALYTICAL + config.debt_node_id + "&stimulus_id=" + config.id;
      } else {
        var link = (config.hot ? LOCATED : NOT_LOCATED) + config.id;
      }
      window.open(link, "_blank");
    },
    setSelectTree(type, prop) {
      switch (type) {
        case "ANALYZABLE":
          switch (prop) {
            case "icom":
              return "mdi-pause-circle-outline";
            case "color":
              return "grey darken-2";
            case "background":
              return "grey lighten-2";
          }
          break;
        case "STIMULATE":
          switch (prop) {
            case "icom":
              return "mdi-play-circle-outline";
            case "color":
              return "grey darken-2";
            case "background":
              return "grey lighten-2";
          }
          break;
        case "ARCHIVED":
          switch (prop) {
            case "icom":
              return "mdi-archive-outline";
            case "color":
              return "grey";
            case "background":
              return "grey lighten-3";
          }
          break;
      }
    },
    icon(date) {
      if (!date) return "play";
      var data_1 = new Date(date);
      var data_2 = new Date();
      if (data_1 <= data_2) return "pause";
      else return "calendar-clock";
    },
    prepareStimulus() {
      if (this.selectedStimulus.length === 0) {
        this.$store.commit("showSnackbar", {
          important: true,
          message: "Selecione ao menos um estímulo para preparar.",
        });
        return;
      }
      this.dialogConfirmPrepare = true;
    },
    confirmPrepareStimulus() {
      var stimulusIds = [];
      
      this.selectedStimulus.forEach((stimulu) => {
        stimulusIds.push(stimulu.id);
      });
      
      this.dialogConfirmPrepare = false;
      
      stimulusService
        .prepareStimulus({
          creditor_id: this.selectedCreditor,
          stimulus_ids: stimulusIds
        })
        .then(async (res) => {
          this.$store.commit("showSnackbar", {
            important: true,
            message: `${stimulusIds.length} ${stimulusIds.length === 1 ? 'estímulo enviado' : 'estímulos enviados'} para preparar!`,
          });
        })
        .catch((e) => {
          this.$store.commit("showSnackbar", `Houve um erro ao preparar os estímulos!`);
        });
      
      this.selectedStimulus = [];
      this.selectAllCheckbox = false;
    },
    getPrepareWeekDays(stimulus) {
      try {
        const prepareWeekDay = stimulus.debt_node && stimulus.debt_node.debt_base && stimulus.debt_node.debt_base.prepare_week_day;
        if (!prepareWeekDay) return [];
        return JSON.parse(prepareWeekDay);
      } catch (e) {
        console.error('Erro ao parsear prepare_week_day:', e);
        return [];
      }
    },
  },
};
</script>

<style lang="css">
.qj-checkbox {
  margin: 43px 0px 0px 48px !important;
  flex: unset !important;
}
.qj-list-draggable .v-list__tile {
  height: 100% !important;
  padding: 8px 0 0 8px;
  display: -webkit-box !important;
  padding: inherit;
  align-items: center;
}

.qj-list-draggable {
  height: 100% !important;
}

.qj-ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.qj-order {
  display: flex;
  border: 1px solid #e0e0e0;
}

.qj-order-list {
  list-style-type: none;
  padding: 0px;
  border-right: 1px solid #e0e0e0;
}
/* .qj-ponto {
  display: flex; 
  justify-content:flex-end
} */
.qj-order-list-item {
  height: 100% !important;
  position: absolute !important;
  width: 32px;
  background: #eee;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 2.20%;
}

.qj-breadcrumbs {
  position: absolute;
  top: -16px;
  left: 32px;
  font-size: 12px;
  line-height: 20px;

  right: 0px;
  padding: 0px 0px 0px 0px;
  margin: 15px 0px 10px 0px;
  border-bottom: 1px solid #e0e0e0;
  border-top: 1px solid #e0e0e0;
}

.qj-breadcrumbs .v-breadcrumbs li:nth-child(2n) {
  padding: 0 4px;
}

.qj-stimulus {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}

.v-list--three-line.v-list--dense .qj-offset-list .v-list__tile {
  height: min-content;
}

</style>